import Collapse from '@mui/material/Collapse';
import Box from '@mui/material/Box';
import NavbarFeaturedContent from './_FeaturedContent';
import NavbarDropdownLinks from './_DropdownLinks';
import { memo } from 'react';

const NavbarDropdownContent = ({ open, index, dropdownCategory, toggleDrawer }) => (
  <Box
    sx={{ position: 'absolute', top: '60px', left: 0, right: 0 }}
    id={dropdownCategory.props.dropdownName.toLowerCase()}
  >
    <Collapse in={open}>
      <Box
        sx={{ pt: 2, background: 'white' }}
        role="presentation"
        onClick={toggleDrawer(index, false)}
        onKeyDown={toggleDrawer(index, false)}
        onMouseLeave={toggleDrawer(index, false)}
      >
        <Box display="flex" justifyContent="center">
          {dropdownCategory?.props?.links?.map((link, index) => (
            // Only show 4 columns on md and 5 columns on lg. Use css to avoid hydration errors
            <NavbarDropdownLinks
              key={`${link?.dropdownName}_index_${index}`}
              link={link}
              length={link?.links?.length}
              dropdownCategory={dropdownCategory}
              sx={{
                display: {
                  xs: index >= 4 ? 'none' : 'block',
                  lg: index >= 5 ? 'none' : 'block',
                  xl: 'block',
                },
              }}
            />
          ))}
          {dropdownCategory?.props?.featured && (
            // Hide on md if cols > 2, Hide on lg if cols > 3
            <NavbarFeaturedContent
              {...dropdownCategory?.props?.featured}
              sx={{
                display: {
                  xs: dropdownCategory?.props?.links?.length > 2 ? 'none' : 'block',
                  lg: dropdownCategory?.props?.links?.length > 3 ? 'none' : 'block',
                  xl: 'block',
                },
              }}
            />
          )}
        </Box>
      </Box>
    </Collapse>
  </Box>
);

export default memo(NavbarDropdownContent);
